// extracted by mini-css-extract-plugin
export default {"image":"Mea-z","loaded":"Nea-z"};